const selectWorkflow = state => {
  return {
    ...state.workflow
  };
};

const selectMemberFek = state => {
  return {
    ...state.workflow.memberFek
  };
};

export { selectWorkflow, selectMemberFek };

